@if (data$ | async; as data) {
  <ng-container *cxFeature="'a11yOrganizationsBanner'">
    @if (routerLink) {
      <cx-generic-link
        [url]="routerLink"
        [target]="getTarget(data)"
        [ariaLabel]="getLinkAriaLabel(data)"
        [attr.title]="!data.headline ? getImageAltText(data) : null"
        >
      </cx-generic-link>
      @if (data.headline) {
        <p class="headline" [innerHTML]="data.headline"></p>
      }
      <cx-media [container]="getImage(data)"></cx-media>
      @if (data.content) {
        <p class="content" [innerHTML]="data.content"></p>
      }
    }
  </ng-container>
  <ng-container *cxFeature="'!a11yOrganizationsBanner'">
    @if (routerLink) {
      <cx-generic-link [url]="routerLink" [target]="getTarget(data)">
        @if (data.headline) {
          <p class="headline" [innerHTML]="data.headline"></p>
        }
        <cx-media [container]="getImage(data)"></cx-media>
        @if (data.content) {
          <p class="content" [innerHTML]="data.content"></p>
        }
      </cx-generic-link>
    }
  </ng-container>
  @if (!routerLink) {
    <div class="no-link">
      @if (data.headline) {
        <p class="headline" [innerHTML]="data.headline"></p>
      }
      <cx-media [container]="getImage(data)"></cx-media>
      @if (data.content) {
        <p class="content" [innerHTML]="data.content"></p>
      }
    </div>
  }
}
